interface CalculatePointPackageProps {
	includedPointPackages: number;
	freePointsPackages: number;
	targetPointPackages: number;
	boughtPointPackages: number;
}

/**
 * Returns the number of point packages to remove or add.
 * Negative value means remove point packages
 * Positive value means add point packages
 */
export function calculatePointPackagesToRemoveOrAdd({
	includedPointPackages,
	freePointsPackages,
	targetPointPackages,
	boughtPointPackages,
}: CalculatePointPackageProps) {
	const nonRemovablePackages = includedPointPackages + freePointsPackages;
	const removeOrAddPackages = targetPointPackages - nonRemovablePackages - boughtPointPackages;

	if (removeOrAddPackages < 0) {
		// Check if the user has enough bought packages to remove
		if (boughtPointPackages >= Math.abs(removeOrAddPackages)) {
			return removeOrAddPackages;
		} else {
			// Remove all bought packages
			return boughtPointPackages ? -boughtPointPackages : 0;
		}
	}
	return removeOrAddPackages;
}
